import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=2676aaac&scoped=true"
import script from "./Action.js?vue&type=script&lang=js&external"
export * from "./Action.js?vue&type=script&lang=js&external"
import style0 from "./Action.scss?vue&type=style&index=0&id=2676aaac&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2676aaac",
  null
  
)

export default component.exports